<template>
<div>
  <v-layout>
    <v-flex xs12>
      <v-radio-group v-if="editable" v-model="model" class="radio-group--update" @change="updateOrigin()">
        <v-radio v-for="(value) in field.values" :key="value.key" :label="`${value.value}`"
                 :value="value.key" class="radio">
        </v-radio>
        <!--        <v-icon v-if="isEdited() && editable" class="light-green&#45;&#45;text form-field__radio-icon&#45;&#45;update"-->
        <!--                @click="updateOrigin">-->
        <!--          check-->
        <!--        </v-icon>-->
      </v-radio-group>

      <div v-else>
        <span v-if="isBaseValid()">
          {{ valueToShow }}
        </span>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on }">
            <span class="incorrect block-span" v-on="on">{{ valueToShow | notEmpty }}</span>
          </template>
          <span>{{ validation.message }}</span>
        </v-tooltip>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {input} from '@/mixins/input'
import InputHelper from '@/plugins/InputHelper'

export default {
  mixins: [input],
  props: ["valueField", "editable", "field", "validation", "context"],
  data() {
    return {
      modelx: "",
      valueToShow: ""
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  methods: {
    isBaseValid() {
      return this.validation.pass
    },
    setUpModel(value) {
      return InputHelper.getRadioObjectByValue(this.field, value) != undefined ?
        InputHelper.getRadioObjectByValue(this.field, value).key : this.valueField
    },
    updateOrigin() {
      this.$emit("updateField", this.model)
    },
    isEdited() {
      return InputHelper.getRadioObjectByValue(this.field, this.valueField) != undefined ?
        (InputHelper.getRadioObjectByValue(this.field, this.valueField).key != this.model) : (this.model != this.valueField)
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getCustomPresentationValue(model) {
      return model;
    },
  },
}
</script>

<style lang="scss" scoped>
.form-field__radio-icon--update {
  position: absolute;
  top: -2rem;
  right: .2rem;
  cursor: pointer;
  z-index: 2000;
}

.radio {
  line-break: anywhere;
}
.radio>label {
  font-size: 11px !important;
}
.block-span{
  display: block;
}

.radio-group--update:first-child {
  margin-top: 2rem;
  position: relative;
  font-size: .9rem;
}
</style>
